// extracted by mini-css-extract-plugin
export var bold = "_sz-0";